<template>
  <admin-layout>
    <template slot="content">
      <create-or-update-application-type
          :mode="mode"
          :dialog="dialog"
          :applicationType="applicationType"
          @loadPage="loadPage(pageNumber)"
          @closeDialog="closeDialog()"
      ></create-or-update-application-type>
      <header-for-list-component
          sectionName="Tipos de Requerimento"
          :items="applicationTypes"
          :totalItems="totalItems"
          :totalPages="totalPages"
          :itemsPerPage="itemsPerPage"
          :pageNumber.sync="pageNumber"
          @loadPage="loadPage($event)"
      />

      <v-layout
          align-center
          justify-space-between
          class="mb-3"
      >
        <v-flex xs4>
          <v-text-field
              v-model="search"
              solo
              label="Buscar Tipo de Requerimento"
              prepend-inner-icon="mdi-magnify"
              hide-details
              :loading="loadingSearch"
              @input="typing()"
          >
            <template v-slot:progress>
              <v-progress-linear
                  v-if="loadingSearch"
                  color="accent"
                  indeterminate
                  height="3"
              ></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
            xs4
            class="text-xs-right">
          <v-btn
              color="primary"
              @click="selectApplicationType(null)">
            <v-icon>mdi-plus</v-icon>
            Novo Tipo de Requerimento
          </v-btn>

        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
            :headers="headers"
            :items="applicationTypes"
            hide-actions
            class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.license_id }}</td>
            <td>{{ props.item.acronym }}</td>
            <td>{{ props.item.name }}</td>
            <td>
              <v-layout row>

                <v-btn icon
                       @click="selectApplicationType(props.item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>

                <delete :applicationType="props.item"
                        @loadPage="loadPage(pageNumber)"></delete>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </template>
  </admin-layout>
</template>

<script>
  import AdminLayout from '@/layouts/AdminLayout';

  import CreateOrUpdateApplicationType
    from '@/components/configurations/application_types/CreateOrUpdateApplicationType';
  import Delete from '@/components/configurations/application_types/Delete';

  import HeaderForListComponent from '@/components/configurations/HeaderForListComponent';
  import ApplicationTypeService from '@/services/applications/configurations/ApplicationTypeService';

  export default {
    name: 'List',
    components: {
      AdminLayout,
      HeaderForListComponent,
      CreateOrUpdateApplicationType,
      Delete
    },
    mounted() {
      this.loadPage(1);
    },
    data() {
      return {
        search: '',
        applicationTypes: [],
        loadingSearch: false,
        interval: null,
        totalItems: 0,
        totalPages: 0,
        itemsPerPage: 20,
        pageNumber: 1,
        headers: [
          { text: 'ID', value: 'id', sortable: false, align: 'center' },
          { text: 'Código', value: 'code', sortable: false, align: 'center' },
          { text: 'ID Licença', value: 'category', sortable: false, align: 'center' },
          { text: 'Sigla', value: 'acronym', sortable: false, align: 'center' },
          { text: 'Nome', value: 'name', sortable: false, align: 'center' },
          { text: 'Ações', value: 'actions', sortable: false, align: 'center' }],
        dialog: false,
        mode: 'create',
        applicationType: null,
      };
    },
    methods: {
      closeDialog() {
        this.dialog = false;
        this.applicationType = null;
      },
      loadPage(pageNumber) {
        this.pageNumber = pageNumber || this.pageNumber;
        if (!this.loadingSearch) this.$store.dispatch('setLoadingDialog', true);
        ApplicationTypeService
          .all({
            limit: this.itemsPerPage,
            page: this.pageNumber,
            q: this.search,
          })
          .then(({ data }) => {
            this.applicationTypes = data.application_types || [];
            this.totalItems = data.total;
            this.totalPages = data.total_pages;
          })
          .finally(() => {
            this.$store.dispatch('setLoadingDialog', false);
            this.loadingSearch = false;
          });
      },
      typing() {
        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.loadingSearch = true;
          this.pageNumber = 1;
          this.loadPage();
        }, 500);
      },
      selectApplicationType(applicationType) {
        if (applicationType === null) {
          this.mode = 'create';
          this.applicationType = null;
          this.dialog = true;
        } else {
          ApplicationTypeService
            .show(applicationType.id)
            .then(({ data }) => {
              this.applicationType = data;
              this.mode = 'update';
              this.dialog = true;
            });
        }
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
